module.exports = __webpack_public_path__ + "static/img/method.abd09a2f.png";